const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/visualizations/main/swimlane/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import i18n from '@/lib/translations/i18n';
import { saveLastVisitedMainVisualization, saveLastVisitedView } from '@/lib/utils/loop-visualizations/lastVisitedVisualizationView';
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/visualizations/main/swimlane/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: ({
    params
  }) => {
    const loopId = Number(params.loopId);
    saveLastVisitedView(loopId, {
      type: 'main'
    });
    saveLastVisitedMainVisualization(loopId, 'swimlane');
  },
  staticData: {
    topNav: {
      title: i18n.t($ => $.roadmaps.title)
    }
  }
});